export const UPLOAD_PHOTO_WIZARD_STATE = {
  CATEGORY_SELECTION: "CATEGORY_SELECTION",
  ROUTES_SELECTION: "ROUTES_SELECTION",
  PHOTOS_SELECTION: "PHOTOS_SELECTION"
}
